import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { MapState } from "./types";

const initialState: MapState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchStateMapAsync = createAsyncThunk(
  "stateMap/fetchStateMap",
  async ({ stateId, year }: { stateId: string; year: string }) => {
    return await api.getStateMap(stateId, year);
  }
);

const stateMapSlice = createSlice({
  name: "stateMap",
  initialState,
  reducers: {
    clearStateMap: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStateMapAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStateMapAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchStateMapAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to fetch state map data";
      });
  },
});

export const { clearStateMap } = stateMapSlice.actions;
export default stateMapSlice.reducer;
